import { Component, OnDestroy, OnInit } from '@angular/core';
import { CaptainDAO } from '../../../../../core/services/dao/captainDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { VesselCaptainMapDAO } from '../../../../../core/services/dao/vesselCaptainMapDAO';

@Component({
  selector: 'app-edit-captains',
  templateUrl: './edit-captains.component.html',
  styleUrls: ['./edit-captains.component.scss'],
})
export class EditCaptainsComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  public model: User;
  public user: User;
  public vessels: Vessel[];
  public active: boolean;
  public adminAccess: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private captainDAO: CaptainDAO,
    private userDao: UserDAO,
    private vesselCaptainMapDao: VesselCaptainMapDAO,
  ) {
    this.user = this.userDao.getCurrentUser();
    this.adminAccess = this.userDao.currentUserIsAdmin();
    const routeSub = this.route.data.subscribe((data) => {
      this.model = data.captains.userResolve;
    });
    const vesselSub = this.vesselCaptainMapDao
      .getVesselsByCaptainId(this.model.captain.id)
      .subscribe((vessels) => {
        this.vessels = vessels;
      });
    this.subs.push(routeSub, vesselSub);
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }
}
